import { CourseOptionView } from '@app/evaluation-settings-menu/HeaderArea.styles'
import images from '@app/images'
import { DropDownMenu } from '@app/ui/dropdown-menu/DropDownMenu'
import { HSpacing } from '@app/ui/rounded-button/RoundedButton.styles'
import theme from '@app/ui/theme'
import AntDesignIcon from '@ovaeasy/react-native-vector-icons/AntDesign'
import * as React from 'react'
import { useWindowDimensions } from 'react-native'
import { EVALUATION_STATUS } from '../domain/ratingStatus'
import { SWEDEN_REGIONS } from '../hooks'
import { DistrictFilter } from './DistrictFilter'

import { RegionFilter } from './RegionFilter'
import { navigate } from '@app/navigation'
import {
  CardIconsContainer,
  FilterButton,
  FilterCardIcon,
  FilterCardIconSearch,
  MobileFilterCard,
  MobileHeaderContainer,
} from './MobileHeaderStyle'

interface HeaderProps {
  onChangeSearchValue: (value: string) => void
  searchValue: string
  filterStatusValue: number
  onChangeFilterValue: (value: string) => void
  regionFilterStatusValue: string
  onChangeRegionFilterValue: (value: string) => void
  districtFilterStatusValue: string
  onChangeDistrictFilterValue: (value: string) => void
  tablet?: boolean
}

const LOGO_IMG_HEIGHT = 44
const SEARCH_ICON_SIZE = 24
const SEARCH_PLACEHOLDER = 'Search'
const FILTER_DROP_WIDTH = 260
const FILTER_DROP_LABEL = 'Filter'
const FILTER_STATUS_LABEL = 'Status'

const MobileHeader = ({
  onChangeSearchValue,
  searchValue,
  filterStatusValue,
  onChangeFilterValue,
  regionFilterStatusValue,
  onChangeRegionFilterValue,
  districtFilterStatusValue,
  onChangeDistrictFilterValue,
  tablet,
}: HeaderProps) => {
  return (
    <MobileHeaderContainer>
      <MobileFilterCard>
        <input
          style={{ width: '100%' }}
          value={searchValue}
          placeholder={SEARCH_PLACEHOLDER}
          onChange={(event) => onChangeSearchValue(event.target.value)}
          className="courses-search-input"
        />
        <CardIconsContainer>
          <FilterCardIcon>
            <img
              src={images.svg.VerticalLine}
              style={{ height: LOGO_IMG_HEIGHT - 2, marginTop: 5 }}
            />
          </FilterCardIcon>
          <FilterCardIconSearch>
            <AntDesignIcon
              name="search1"
              size={SEARCH_ICON_SIZE}
              color={theme.colors.primary}
            />
          </FilterCardIconSearch>
        </CardIconsContainer>
      </MobileFilterCard>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ width: 100 }}>
          <FilterButton
            onClick={() => navigate('SearchOverview')}
            style={{ width: '100%', height: '100%' }}
          >
            {FILTER_DROP_LABEL}
          </FilterButton>
        </div>
        <HSpacing size={10} />
        <div style={{ width: 100 }}>
          <RegionFilter
            onChangeFilterValue={onChangeRegionFilterValue}
            filterStatusValue={regionFilterStatusValue}
          />
        </div>
        <HSpacing size={10} />
        <div style={{ width: 100 }}>
          <DistrictFilter
            onChangeFilterValue={onChangeDistrictFilterValue}
            filterStatusValue={districtFilterStatusValue}
            region={SWEDEN_REGIONS.find(
              (region) => region.name === regionFilterStatusValue
            )}
          />
        </div>
      </div>
    </MobileHeaderContainer>
  )
}

export { MobileHeader }
